import { render, staticRenderFns } from "./DocAcaoManutencao.vue?vue&type=template&id=84d0ab6a&scoped=true&lang=pug&"
import script from "./DocAcaoManutencao.vue?vue&type=script&lang=js&"
export * from "./DocAcaoManutencao.vue?vue&type=script&lang=js&"
import style0 from "./DocAcaoManutencao.vue?vue&type=style&index=0&id=84d0ab6a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d0ab6a",
  null
  
)

export default component.exports